export default {
  apiBaseUrl: "https://myliberte.xyz/api/",
  accessTokenKey: "Authorization",
  bearerPrefix: "bearer",
  accessDeniedPath: "/access-denied",
  expires: 365,
  secure: true
  // apiBaseUrl: 'http://192.168.1.5:3000/api/',
  // accessTokenKey: 'Authorization',
  // bearerPrefix: 'bearer',
  // accessDeniedPath: '/access-denied',
  // expires: 365,
  // secure: false
};
